let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8ybFV")).then(() => parcelRequire('8wx8h'));